import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { isEqual } from "lodash-es"
import {
  formSubmissionCountsByCategory,
  getCategories,
  getSelectedCategorySlug,
  switchSolution,
} from "reduxSlices/formSubmissionTableSlice"
import { CategorySelect } from "shared/selects"
import { SidebarCollapsibleContent } from "shared/Sidebar"

const SubmissionCategoryFilter = () => {
  const dispatch = useDispatch()

  const categories = useSelector(getCategories, isEqual)
  const formSubmissionCounts = useSelector(formSubmissionCountsByCategory, isEqual)
  const selectedCategorySlug = useSelector(getSelectedCategorySlug)

  const changeSelectedCategory = (categorySlug) => {
    if (categorySlug === selectedCategorySlug) return

    dispatch(switchSolution({ categorySlug }))
  }

  const categoriesWithCounts = categories.map((category) => (
    {
      ...category,
      name: `${category.name} (${formSubmissionCounts[category.id.toString()] ?? 0})`,
    }
  ))

  return (
    <SidebarCollapsibleContent title="Solution">
      <CategorySelect
        className="bg-white text-sm"
        isFullWidth
        options={categoriesWithCounts}
        value={selectedCategorySlug}
        onChange={changeSelectedCategory}
        backspaceDelete={false}
      />
    </SidebarCollapsibleContent>
  )
}

export default SubmissionCategoryFilter
